export default __webpack_public_path__ + "static/media/avatar_alison8.776074c8.mp3";